// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gSulj{position:relative}.gSulj.eEn6q .ui.input input{padding-right:calc(var(--character-counter-width, 4.5rem) + .5rem)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `gSulj`,
	"hasCounter": `eEn6q`
};
module.exports = ___CSS_LOADER_EXPORT___;
